import React from 'react';
// react bootstrap
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';

// image
import NotFoundImage from '../../images/not_found_background.svg';

const NotFound = () => {
  return (
    <Container className='pt-5'>
      <Image className='text-center' src={NotFoundImage} fluid />
    </Container>
  );
};

export default NotFound;
